import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidator} from '../../../services/custom-validator';

@Component({
  selector: 'app-service-configuration-api',
  templateUrl: './service-configuration-runtime.component.html',
  styleUrls: ['./service-configuration-runtime.component.css']
})
export class ServiceConfigurationRuntimeComponent implements OnInit {

  @Input() modalTitle: string;
  componentForm: FormGroup;
  objInitialState;
  config;
  error;
  submitted;

  pleaseWait = false;
  get formData() { return this.componentForm.controls; }

  constructor(
    private nodeConfigService: NodeConfigurationService,
    private modalService: GenericModalService,
    private formBuilder: FormBuilder, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.submitted= false;

    if (this.objInitialState){
      this.config = this.objInitialState;
    }
    this.createForm();
    this.loadConfigs();

  }

  createForm() {
    this.componentForm = this.formBuilder.group({
      communicationKey:  [null],
      attachmentRepositoryType: [null],
      attachmentRepositoryPath:[null],
      pendingInstancesQueue:[null, CustomValidator.trimRequired],
      syncInstancesQueue:[null, CustomValidator.trimRequired],
      syncResultInstancesQueue:[null, CustomValidator.trimRequired],
      pendingBatchInstancesQueue:[null, CustomValidator.trimRequired],
      pendingBatchItemQueue:[null, CustomValidator.trimRequired],
      scheduledNextStatesExecutionQueue:[null, CustomValidator.trimRequired],
      interactionTimeoutQueue:[null, CustomValidator.trimRequired],
      overrideQueue:[null, CustomValidator.trimRequired],
      suspendedInstancesQueue:[null, CustomValidator.trimRequired],
      syncInstancesQueueMessageMaxLifetime:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      taskTimeout:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      batchStartSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      batchExecutionSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      syncExecutionSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      asyncExecutionSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      interactionTimeoutSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      overrideSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      interactionQueueSlots:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      schedulingServiceFrequency:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      suspendedInstanceServiceFrequency:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      periodRecalculateInstanceDistribution:[null],
      overrideRetryInterval:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      inMemoryServiceIp:[null,[ CustomValidator.trimRequired, Validators.maxLength(100) ]],
      inMemoryServicePort:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      billingServerUri:[null],
      batcherNetworkAddress:[null],
      interactionInstanceQueue:[null, CustomValidator.trimRequired],
    });
  }

  loadConfigs() {
    this.error = '';
    this.nodeConfigService.getByNode(this.config.machineId, this.config.hostName, 1)
      .subscribe(result => {
        if (result) {
          this.componentForm.patchValue({
            communicationKey:  result.communicationKey,
            attachmentRepositoryType: result.attachmentRepositoryType.toString(),
            attachmentRepositoryPath:  result.attachmentRepositoryPath,
            pendingInstancesQueue:  result.pendingInstancesQueue,
            syncInstancesQueue:  result.syncInstancesQueue,
            syncResultInstancesQueue:  result.syncResultInstancesQueue,
            pendingBatchInstancesQueue:  result.pendingBatchInstancesQueue,
            pendingBatchItemQueue:  result.pendingBatchItemQueue,
            scheduledNextStatesExecutionQueue:  result.scheduledNextStatesExecutionQueue,
            interactionTimeoutQueue:  result.interactionTimeoutQueue,
            overrideQueue:  result.overrideQueue,
            suspendedInstancesQueue:  result.suspendedInstancesQueue,
            syncInstancesQueueMessageMaxLifetime:  result.syncInstancesQueueMessageMaxLifetime,
            taskTimeout:  result.taskTimeout,
            batchStartSlots:  result.batchStartSlots,
            batchExecutionSlots:  result.batchExecutionSlots,
            syncExecutionSlots:  result.syncExecutionSlots,
            asyncExecutionSlots:  result.asyncExecutionSlots,
            interactionTimeoutSlots:  result.interactionTimeoutSlots,
            overrideSlots:  result.overrideSlots,
            schedulingServiceFrequency:  result.schedulingServiceFrequency,
            suspendedInstanceServiceFrequency:  result.suspendedInstanceServiceFrequency,
            periodRecalculateInstanceDistribution:  result.periodRecalculateInstanceDistribution,
            overrideRetryInterval:  result.overrideRetryInterval,
            inMemoryServiceIp:  result.inMemoryServiceIp,
            inMemoryServicePort:  result.inMemoryServicePort,
            billingServerUri:  result.billingServerUri,
            batcherNetworkAddress:  result.batcherNetworkAddress,
            interactionQueueSlots:  result.interactionQueueSlots,
            interactionInstanceQueue:  result.interactionInstanceQueue,
          });
          this.pleaseWait = false;
          // @ts-ignore
          $('#cardQueues').CardWidget('collapse');
          // @ts-ignore
          $('#cardThreads').CardWidget('collapse');
          // @ts-ignore
          $('#cardFrequency').CardWidget('collapse');
          this.onAttachmentRepositoryTypeChange();

        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  onClose() {
    this.bsModalRef.hide();
  }

  onSave() {
    this.error = '';
    this.pleaseWait = true;
    const obj = this.componentForm.getRawValue();
    obj.machineId = this.config.machineId;
    obj.hostName = this.config.hostName;
    this.nodeConfigService.updateRuntime(obj).subscribe(
      () => {
        this.pleaseWait = false;
        this.submitted = true;
        setTimeout(() => {  this.submitted = false; }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.error = error1;
      }
    );
  }

  onAttachmentRepositoryTypeChange() {
    if (this.formData.attachmentRepositoryType.value == "1"){
      this.componentForm.get('attachmentRepositoryPath').setValidators(CustomValidator.trimRequired);
    } else {
      this.componentForm.get('attachmentRepositoryPath').clearValidators();
      this.componentForm.patchValue({
        attachmentRepositoryPath: null
      });
      this.componentForm.updateValueAndValidity();
    }
  }

}
